import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BypassSecurityTrustResourceUrl } from '@core/pipes/safe-url/safe-url.pipe';

@NgModule({
  imports: [CommonModule, BypassSecurityTrustResourceUrl],
  exports: [BypassSecurityTrustResourceUrl],
})
export class SafeURLModule {}
